module.exports = __webpack_public_path__ + "img/umbrella-simple.6a071f8b.svg";